import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Card,
  CardContent,
  Avatar,
  IconButton,
  Button,
  Container,
  Tabs,
  Tab,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import InfoIcon from '@mui/icons-material/Info';

import DateBar from '../../../components/DateBar';
import Navigation from '../../../components/Navigation';

const HolidayReview = () => {
  const [tabValue, setTabValue] = useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const approvedDates = [1, 3, 5, 7];
  const requestedDates = [2, 6, 8, 12];
  return (
    <Container
      maxWidth="sm"
      sx={{
        paddingTop: 4,
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography variant="h5" align="center">
        Holidays Requests Review
      </Typography>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        centered
        sx={{ marginTop: 2 }}
      >
        <Tab label="Holiday" />
        <Tab label="Over Time" />
      </Tabs>

      <TextField
        fullWidth
        placeholder="Search by alpha, department, date"
        variant="outlined"
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        sx={{ mb: 3, mt: 3 }}
      />

      <Card variant="outlined" sx={{ mb: 2 }}>
        <CardContent sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar src="/path-to-image.jpg" alt="Molly Thomson" sx={{ mr: 2 }} />
          <Box flex="1">
            <Typography variant="body1" fontWeight="bold">
              Molly Thomson
            </Typography>
            <Typography variant="body2">20/10/2024</Typography>
          </Box>
          <Button variant="outlined" color="error" size="small">
            remaining
          </Button>
        </CardContent>
        <DateBar
          approvedDates={approvedDates}
          requestedDates={requestedDates}
        />
      </Card>

      <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
          <Box display="flex" alignItems="center" mb={2}>
            <Avatar
              src="/path-to-image.jpg"
              alt="Molly Thomson"
              sx={{ mr: 2 }}
            />
            <Typography variant="body1" fontWeight="bold">
              Molly Thomson
            </Typography>
          </Box>
          <TextField
            fullWidth
            label="Message"
            variant="outlined"
            InputProps={{
              readOnly: true,
              sx: { height: '100px', alignItems: 'flex-start' },
            }}
            value={'Hi'}
            sx={{ mb: 2 }}
          />
          <Box display="flex" justifyContent="space-around">
            <Box
              sx={{
                width: '50%',
              }}
            >
              <Button
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mb: 1 }}
              >
                View Request
              </Button>
            </Box>
            <Box
              sx={{
                width: '50%',
              }}
              display="flex"
              justifyContent="space-around"
            >
              <IconButton color="success">
                <CheckIcon />
              </IconButton>
              <IconButton color="error">
                <ClearIcon />
              </IconButton>
              <IconButton color="info">
                <InfoIcon />
              </IconButton>
            </Box>
          </Box>
        </CardContent>
      </Card>
      <Navigation />
    </Container>
  );
};

export default HolidayReview;
